import {Link} from "react-router-dom";
import Icon from "../../components/selfcare/Icon.tsx";
import IconArrow from "../icons/IconArrow.tsx";

export interface RelatedArticle {
    category: string
    article: string
    name: string
}

export default function RelatedArticlesComponent(props: {articles: RelatedArticle[]}) {
    return (
        <aside className="help-article-related">
            <h3>Se også</h3>
            <div className="help-menu help-menu--related">
                {props.articles.map((article, index) => {
                    return (
                        <ArticleLink key={index} article={article}/>
                    )
                })}
            </div>
        </aside>
    )
}

function ArticleLink(props: {article: RelatedArticle}) {
    return (
        <Link
            className="item"
            to={`/hjaelp/${props.article.category}/${props.article.article}`}
        >
            <Icon component={IconArrow}/>
            <span className="text">{props.article.name}</span>
        </Link>
    )
}
